import { ElementType } from 'react'
import React, { ComponentType, SVGProps } from 'react'

import { Button, ButtonProps } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import styles from './product-toggle-button.module.scss'

export type ProductMinButtonProps = {
	iconId: ComponentType<SVGProps<SVGSVGElement>>
	className?: string
} & ButtonProps<ElementType>

export const ProductToggleButton = ({
	iconId,
	className,
	children,
	...otherProps
}: ProductMinButtonProps): JSX.Element => (
	<Button {...otherProps} className={styles.productToggleButton}>
		<Icon icon={iconId} aria-hidden="true" width={24} height={24} className={className} />
		<span className={styles.text}>{children}</span>
	</Button>
)
